export default __webpack_public_path__ + "static/email-ca906159309b9c7a93f1889c6efcc198.png";